import { inject, injectable } from 'inversify';
import { TYPES } from '../di/types';
import { apiClient } from './NativeApiClient';

export interface CampusService {
  submitTicket(ticketPayload: CampusTicketPayload): Promise<void>;
}

export interface CampusTicketPayload {
  requester: string;
  subject: string;
  description: string;
  tags: string[];
}

@injectable()
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class CampusServiceImpl implements CampusService {
  constructor(@inject(TYPES.AppConfig) private readonly appConfig: AppConfig) {}

  public async submitTicket(ticketPayload: CampusTicketPayload): Promise<void> {
    return await apiClient.post(
      this.appConfig.tapingoTicketsUrl,
      ticketPayload,
    );
  }
}
